import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Accordion, Lightbox, Tooltip } from 'rds-core'
import i18n from './lang/i18n.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Emitter from 'tiny-emitter'

import '../node_modules/rds-core/src/styles/rds-core.scss'
// import '@/assets/src/styles/rds-core.scss';

const app = createApp(App)

// app.config.globalProperties.$msalInstance = {};
// TODO: make the emitter a service
// app.config.globalProperties.$emitter = new Emitter();

app.provide('msalInstance', {})
app.provide('emitter', new Emitter())

app
  .use(store)
  .use(VueAxios, axios)
  .use({ Accordion, Lightbox, Tooltip })
  .use(i18n)
  .use(router)
  .mount('#app')
